import { DocumentStatus } from '../graphql';

export const DOCUMENT_STATUS_LABELS: Record<DocumentStatus, string> = {
  [DocumentStatus.HumanReview]: 'Human Review',
  [DocumentStatus.MissingInformation]: 'Missing Information',
  [DocumentStatus.ReadyForDownload]: 'Ready for Download',
  [DocumentStatus.ReadyToSubmit]: 'Ready to Submit',
};
